import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  primaryBgColor: '#4A90E2',
  primaryTextColor: '#FFFFFF',
  secondaryBgColor: '#3498DB',
  secondaryTextColor: '#FFFFFF',
  updateTimestamp: Date.now() // Used to force re-renders
};

export const brandingSlice = createSlice({
  name: 'branding',
  initialState,
  reducers: {
    updateBranding: (state, action) => {
      // Update all branding properties
      return {
        ...state,
        ...action.payload,
        updateTimestamp: Date.now() // Update timestamp to trigger re-renders
      };
    },
    updatePrimaryColors: (state, action) => {
      // Update just primary colors
      const { primaryBgColor, primaryTextColor } = action.payload;
      state.primaryBgColor = primaryBgColor || state.primaryBgColor;
      state.primaryTextColor = primaryTextColor || state.primaryTextColor;
      state.updateTimestamp = Date.now();
    },
    updateSecondaryColors: (state, action) => {
      // Update just secondary colors
      const { secondaryBgColor, secondaryTextColor } = action.payload;
      state.secondaryBgColor = secondaryBgColor || state.secondaryBgColor;
      state.secondaryTextColor = secondaryTextColor || state.secondaryTextColor;
      state.updateTimestamp = Date.now();
    },
    refreshBranding: (state) => {
      // Just update timestamp to force re-render of components using the branding
      state.updateTimestamp = Date.now();
    }
  }
});

export const { 
  updateBranding, 
  updatePrimaryColors, 
  updateSecondaryColors,
  refreshBranding 
} = brandingSlice.actions;

export default brandingSlice.reducer; 